import { render, staticRenderFns } from "./Admisiones.vue?vue&type=template&id=7dc6bbeb"
import script from "./Admisiones.vue?vue&type=script&lang=js"
export * from "./Admisiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports